<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/hr/employee' }">人事管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="search.name" placeholder="请输入姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="search.status" class="width-max" clearable placeholder="请选择状态">
              <el-option v-for="item in statusOptions"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" native-type="submit">搜索</el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary" size="small" icon="el-icon-refresh" @click="onRefresh()"></el-button>
      </template>
      <el-table :data="table"
                border
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="employee_id" label="员工ID" align="center" />
        <el-table-column prop="employee_name" label="员工姓名" align="center"/>
        <el-table-column prop="employee_birthday" label="员工生日" align="center" />
        <el-table-column prop="send_at" label="发送日期" align="center" />
        <el-table-column prop="gift" label="礼物" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.gift && String(scope.row.gift).length > 10"
                  style="cursor: pointer; color: #409EFF;"
                  @click="onShowGiftDetail(scope.row.gift)">
              {{ String(scope.row.gift).slice(0, 10) + '...' }}
            </span>
            <span v-else>{{ scope.row.gift || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bcc" label="密送" align="center">
          <template slot-scope="scope">
            {{ Array.isArray(scope.row.bcc) ? scope.row.bcc.join(', ') : (scope.row.bcc || '-') }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="image" label="贺卡图片" align="center" /> -->
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="statusTagType(scope.row.status)" size="mini">
              {{ formatStatus(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center" />
        <el-table-column prop="updated_at" label="更新时间" align="center" />
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button v-if="Number(scope.row.status) === 0" type="text" size="small" @click="onCancelBirthday(scope.row)">取消</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import table from '@core/mixins/table'

export default {
  mixins: [table],
  data () {
    return {
      searchRules: {},
      search: {
        name: '',
        status: null,
      },
      searchFieldType: {
        status: Number,
      },
      table: [],
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      statusOptions: [
        { label: '待发送', value: 0 },
        { label: '已发送', value: 1 },
        { label: '发送失败', value: 2 },
        { label: '已取消', value: 3 },
      ],
    }
  },
  methods: {
    getTableData (params) {
      return request.common('getBirthdayGreetingsRecord', params)
    },
    formatStatus (status) {
      const v = Number(status)
      if (v === 0) return '待发送'
      if (v === 1) return '已发送'
      if (v === 2) return '发送失败'
      if (v === 3) return '已取消'
      return status === null || status === undefined || status === '' ? '-' : String(status)
    },
    statusTagType (status) {
      const v = Number(status)
      if (v === 0) return 'info'
      if (v === 1) return 'success'
      if (v === 2) return 'danger'
      if (v === 3) return 'warning'
      return ''
    },
    resetSearch () {
      const form = this.$refs.searchForm
      form && form.resetFields()
      this.onSearch()
    },
    onShowGiftDetail (gift) {
      const text = gift === null || gift === undefined || gift === '' ? '-' : String(gift)
      this.$alert(text, '礼物详情', {
        confirmButtonText: '确定',
      })
    },
    onCancelBirthday (row) {
      this.$confirm('确认取消生日发送吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          record_id: row && row.id ? row.id : null,
        }
        return request.common('cancelBirthdayGreetings', params)
      }).then(() => {
        this.$message.success('取消成功')
        this.onRefresh()
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/hr/pages/employee/birthday-list.vue